/**
 * A local hint that this browser started an övningstenta that is not yet handed in. Exams are
 * self-started mocks, so the guards only fail closed (when `GET /api/exam/current` times out or
 * errors) for a student who has the hint; everyone else is let through rather than locked out of
 * practice by a flaky request. It is a convenience, not a security boundary: the server answer
 * always wins and re-syncs it. Every access is guarded: storage may be blocked or full.
 */
export const EXAM_HINT_KEY = "mf.exam.started";

export function setExamHint(): void {
  try {
    window.localStorage.setItem(EXAM_HINT_KEY, "1");
  } catch {
    /* storage unavailable: no hint */
  }
}

export function clearExamHint(): void {
  try {
    window.localStorage.removeItem(EXAM_HINT_KEY);
  } catch {
    /* storage unavailable */
  }
}

export function hasExamHint(): boolean {
  try {
    return window.localStorage.getItem(EXAM_HINT_KEY) === "1";
  } catch {
    return false;
  }
}
